import React, { useEffect, useState } from 'react';
import AgileURLParameterTypes from '@components/agile/types/AgileURLParameterTypes';
import { useAppSelector } from '@store/hooks';
import { selectProgram } from '@store/slices/programSlice';
import '@components/productReadiness/ProductReadinessTable.css';
import Masthead, { MastheadTitle } from '@amzn/meridian/masthead';
import Row from '@amzn/meridian/row';
import ProductReadinessTable from '@components/productReadiness/ProductReadinessTable';
import Heading from '@amzn/meridian/heading';
import { InputAsinsValidationUtils } from '@components/agile/utils/InputAsinsValidationUtils';
import Textarea from '@amzn/meridian/textarea';
import Button from '@amzn/meridian/button';
import { useSearchParams } from 'react-router-dom';
import StoreSelector from '../selectors/ProgramStoreSelector';
import NavigationHelper from '@components/agile/utils/URLParametersUtils';

export interface ProductReadinessProps {
  urlParams: AgileURLParameterTypes;
  setUrlParameter: (value: AgileURLParameterTypes) => void;
}

const ProductReadiness = (props: ProductReadinessProps) => {
  const { urlParams, setUrlParameter } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const programType = useAppSelector(selectProgram);
  const [store, setStore] = useState(urlParams.storeId);
  const [inputAsins, setInputAsins] = useState<string>('');
  const asinList = Array.from(new Set(inputAsins.split(/[,\s]+/)));
  const [storeParameter, setStoreParameter] = useState<string>('');
  const [asinListParameter, setAsinListParameter] = useState<string[]>([]);
  const [date] = useState(urlParams.date);
  const [selectedZoneId] = useState(urlParams.zoneId);

  if (programType == null) {
    throw new Error('ProgramType is not initialized');
  }

  useEffect(() => {
    setSearchParams(
      NavigationHelper.createSearchParams(
        {
          storeId: store,
          date,
        },
        urlParams.demo,
      ),
    );
    setUrlParameter({
      storeId: store,
      date,
      zoneId: selectedZoneId,
      demo: urlParams.demo,
    });
  }, [date, selectedZoneId, setSearchParams, setUrlParameter, store, urlParams.demo]);
  const onClick = () => {
    setStoreParameter(store);
    setAsinListParameter(asinList);
  };

  return (
    <Masthead size="large" backgroundColor="surface">
      <MastheadTitle>
        <Heading level={2}>Product Readiness</Heading>
        <Row>
          <StoreSelector selectedStoreId={store} onStoreSelect={setStore} />
          <Textarea
            value={inputAsins}
            onChange={setInputAsins}
            placeholder="Enter a list of ASINs...."
            error={!InputAsinsValidationUtils(asinList)}
            resize="auto"
            rows={5}
            errorMessage={!InputAsinsValidationUtils(asinList) ? 'Invalid List of Asins' : null}
            helperText="For multiple ASINs use commas (,) eg: B00XXXXXFW, B00XXXXXF6"
          />
          <Button onClick={onClick} disabled={!store || !InputAsinsValidationUtils(asinList)}>
            Search
          </Button>
        </Row>
      </MastheadTitle>
      {storeParameter && asinListParameter.length > 0 && (
        <ProductReadinessTable asinList={asinListParameter} storeId={storeParameter} />
      )}
    </Masthead>
  );
};

export default ProductReadiness;
